/**
 *使用配额 vm
 *@author xujinjiang
 *@date 2022/7/12 11:52
 */

import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { AuditLogServiceImpl } from '@/service/AuditLogServiceImpl';
import { actionType } from '@/constant/ActionType';
import { CommonUtil } from '@/utils/CommonUtil';
import { OrderListServiceImpl } from '@/service/OrderListServiceImpl';

export class OrderListViewModel extends BaseViewModel {
  totalCount = 0;
  loading: any;
  actionType = actionType;

  tableBodyEl: any;

  orderList = [];
  tableHeight = window.innerHeight - 250;

  isShowNull = false;
  developUser: any;

  mounted() {
    this.developUser = CommonUtil.getDevelopUser();
    this.loading = CommonUtil.loading('.el-table__body-wrapper');
    this.tableBodyEl = document.querySelector('.el-table__body-wrapper') as HTMLElement;
    if (this.tableBodyEl) {
      this.tableBodyEl.style.minHeight = '100px';
    }
    this.getOrderList();
    window.addEventListener('resize', () => {
      this.tableHeight = window.innerHeight - 250;
    });
  }

  async getOrderList() {
    let result;
    try {
      result = await OrderListServiceImpl.getInstance().getOrderList(this.developUser.appKey);
    } catch (e) {
      console.error(e);
      return;
    }
    this.orderList = result.orderList;
    console.log(result);
    this.loading.close();
    this.tableBodyEl.style.minHeight = '0px';
    this.isShowNull = true;
  }
}
